import React, { useEffect, useMemo, useState } from 'react';
import { Tabs, Tab } from '@mui/material';
import { ProductCategory } from '@api/ProductCategories/ProductCategory';
import { showAlertError } from '@utils/Alerts/Error';
import ProductCategoriesService from '@api/ProductCategories/ProductCategoryCtrl';

interface ProductCategoriesGridProps {
    enabled: boolean;
    productCategoryIdSelected?: string;
    onSelectProductCategoryId: (productCategoryId?: string) => void;
}

const ProductCategoriesGrid: React.FunctionComponent<ProductCategoriesGridProps> = (props) => {
    const { enabled, productCategoryIdSelected, onSelectProductCategoryId } = props;
    const productCategoriesService = useMemo(() => new ProductCategoriesService(), []);
    const [categories, setCategories] = useState<ProductCategory[]>([]);

    const getData = async () => {
        try {
            const data = await productCategoriesService.getProductCategories();
            setCategories([
                {
                    id: undefined, // Representa "Todo"
                    priority: 0,
                    name: 'Todo'
                },
                ...data
            ]);
        } catch (error) {
            showAlertError(error);
        }
    };

    useEffect(() => {
        void getData();
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        // Regresamos el valor a undefined si selecciona "Todo"
        onSelectProductCategoryId(newValue === 'todo' ? undefined : newValue);
    };

    // Si no hay ID seleccionado, asumimos que está en "Todo"
    const currentValue = productCategoryIdSelected || 'todo';

    return (
        <Tabs
            value={currentValue}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
                alignItems: 'center',
                opacity: enabled ? 1 : 0.5,
                pointerEvents: enabled ? 'auto' : 'none'
            }}
        >
            {categories.map((productCategory, index) => (
                <Tab key={index} value={productCategory.id || 'todo'} label={productCategory.name} />
            ))}
        </Tabs>
    );
};

export default ProductCategoriesGrid;
